document.addEventListener('DOMContentLoaded', function () {
  var articleSection = document.getElementById('section-blog');
  if (!articleSection) {
    return;
  }

  var articleBody = articleSection.querySelector('.rte[itemprop="articleBody"]');
  var toc = articleSection.querySelector('[data-article-toc]');
  var tocList = articleSection.querySelector('[data-article-toc-list]');

  if (!articleBody || !toc || !tocList) {
    return;
  }

  var headings = Array.prototype.slice.call(articleBody.querySelectorAll('h2'));
  if (headings.length < 2) {
    headings = Array.prototype.slice.call(articleBody.querySelectorAll('h3'));
  }

  if (headings.length < 2) {
    return;
  }

  var slugCounts = {};

  var slugify = function (value) {
    var base = (value || '')
      .toLowerCase()
      .trim()
      .replace(/&amp;/g, ' and ')
      .replace(/[^a-z0-9\s-]/g, '')
      .replace(/\s+/g, '-')
      .replace(/-+/g, '-');

    if (!base) {
      base = 'section';
    }

    if (slugCounts[base]) {
      slugCounts[base] += 1;
      return base + '-' + slugCounts[base];
    }

    slugCounts[base] = 1;
    return base;
  };

  headings.forEach(function (heading) {
    var text = heading.textContent.replace(/\s+/g, ' ').trim();
    if (!text) {
      return;
    }

    if (!heading.id) {
      heading.id = slugify(text);
    }

    var item = document.createElement('li');
    item.className = 'article-toc__item';

    var link = document.createElement('a');
    link.className = 'article-toc__link';
    link.href = '#' + heading.id;
    link.textContent = text;

    item.appendChild(link);
    tocList.appendChild(item);
  });

  if (!tocList.children.length || tocList.children.length < 2) {
    tocList.innerHTML = '';
    return;
  }

  toc.classList.add('is-visible');
});